import React from 'react';
import { Calendar, Trophy, Users } from 'lucide-react';
import BentoWidgetCard, { WidgetQuestion } from '../BentoWidgetCard';
import { getEventsData } from '../../../../utils/aiBriefingsData';
interface EventiChallengeWidgetProps {
  onHide?: () => void;
  onAsk?: (question: string) => void;
}
const EventiChallengeWidget: React.FC<EventiChallengeWidgetProps> = ({
  onHide,
  onAsk
}) => {
  const data = getEventsData();
  const questions: WidgetQuestion[] = [{
    id: '1',
    text: 'Quali challenge funzionano meglio?'
  }, {
    id: '2',
    text: 'Come aumentare partecipazione?'
  }];
  return <BentoWidgetCard id="eventi-challenge" title="Eventi & Challenge" size="M" lastUpdated="7 min fa" questions={questions} onHide={onHide} onAsk={onAsk} data-id="element-1371">
      <div className="grid grid-cols-3 gap-3 mb-4" data-id="element-1372">
        <div className="bg-blue-50 rounded-lg p-3" data-id="element-1373">
          <Users className="h-4 w-4 text-blue-600 mb-1" data-id="element-1374" />
          <p className="text-xs text-blue-700" data-id="element-1375">Partecipanti</p>
          <p className="text-lg font-bold text-blue-900" data-id="element-1376">
            {data.participation.toLocaleString()}
          </p>
        </div>
        <div className="bg-green-50 rounded-lg p-3" data-id="element-1377">
          <Trophy className="h-4 w-4 text-green-600 mb-1" data-id="element-1378" />
          <p className="text-xs text-green-700" data-id="element-1379">Completamento</p>
          <p className="text-lg font-bold text-green-900" data-id="element-1380">
            {data.completionRate}%
          </p>
        </div>
        <div className="bg-purple-50 rounded-lg p-3" data-id="element-1381">
          <Calendar className="h-4 w-4 text-purple-600 mb-1" data-id="element-1382" />
          <p className="text-xs text-purple-700" data-id="element-1383">Prossimi</p>
          <p className="text-lg font-bold text-purple-900" data-id="element-1384">
            {data.upcomingRegistrations}
          </p>
        </div>
      </div>

      <div data-id="element-1385">
        <p className="text-xs font-semibold text-gray-900 mb-2" data-id="element-1386">
          Best Challenge
        </p>
        <div className="space-y-2" data-id="element-1387">
          {data.bestChallenges.map((challenge, index) => <div key={index} className="bg-gray-50 rounded-lg p-2" data-id="element-1388">
              <div className="flex items-center justify-between mb-1" data-id="element-1389">
                <p className="text-xs font-medium text-gray-900" data-id="element-1390">
                  {challenge.name}
                </p>
                <span className="text-xs font-bold text-green-600" data-id="element-1391">
                  {challenge.completionRate}%
                </span>
              </div>
              <p className="text-xs text-gray-600" data-id="element-1392">
                {challenge.participants} partecipanti
              </p>
            </div>)}
        </div>
      </div>
    </BentoWidgetCard>;
};
export default EventiChallengeWidget;